import { useContext } from 'react'
import IsMobileContext from './IsMobileProvider'

const useIsMobile = () => {
    return useContext(IsMobileContext)
}
export default useIsMobile
